import { createSelector } from '@ngrx/store';
import { getSharedState, SharedState } from '../shared.reducer';

const getAttributeLocaleFields = createSelector(getSharedState, (state: SharedState) => state.locales.attributeLocaleFields);
const getLocaleMappings = createSelector(getSharedState, (state: SharedState) => state.locales.localeMappings);
const getLocaleOptions = createSelector(getSharedState, (state: SharedState) => state.locales.localeOptions);
const getLocaleSelected = createSelector(getSharedState, (state: SharedState) => state.locales.localeSelected);
const getOrigin = createSelector(getSharedState, (state: SharedState) => state.locales.origin);
const getSaved = createSelector(getSharedState, (state: SharedState) => state.locales.saved);

export const LocalesSelectors = {
    getAttributeLocaleFields,
    getLocaleMappings,
    getLocaleOptions,
    getLocaleSelected,
    getOrigin,
    getSaved
};
